import { State } from "@/store/modules/superSpace/index";

const getSuperSpaces = (state: State): any => {
  return state.superSpaces;
};

const getSuperSpace = (state: State): any => {
  return state.superSpace;
};

const getSuperSpacesAvailablePage = (state: State): number => {
  return state.superSpacesAvailablePage;
};

const getLastPageSuperSpaces = (state: State): number => {
  return state.lastPageSuperSpaces;
};

export default {
  getSuperSpaces,
  getSuperSpacesAvailablePage,
  getLastPageSuperSpaces,
  getSuperSpace,
};
